module.exports = __webpack_public_path__ + "img/cornelia.60528a2e.jpeg";